"use strict";

exports.__esModule = true;
exports.defaultProps = void 0;
const defaultProps = {
  disabled: false,
  bordered: false,
  readOnly: false,
  clearable: false,
  rounded: false,
  animated: true,
  underlined: false,
  shadow: true,
  fullWidth: false,
  contentClickable: false,
  contentRightStyling: true,
  contentLeftStyling: true,
  required: false,
  width: 'initial',
  size: 'md',
  color: 'default',
  helperColor: 'default',
  status: 'default',
  borderWeight: 'normal',
  autoComplete: 'off',
  className: '',
  placeholder: '',
  initialValue: ''
};
exports.defaultProps = defaultProps;